export default "__VITE_ASSET__CaVVyG9G__"